import React from "react"

import { ProjectTeamInvitationListOverlay } from "./ProjectTeamInvitationListOverlay"
import { useProjectTeamInvitationListOverlayModel } from "./model/useProjectTeamInvitationListOverlayModel"

export const ProjectTeamInvitationListOverlayConnector = React.memo(() => {
  return (
    <ProjectTeamInvitationListOverlay
      {...useProjectTeamInvitationListOverlayModel()}
    />
  )
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROJECT_TEAM_INVITATION_LIST_OVERLAY: null
  }
}
